import styled, {css} from "styled-components"
import {WorkSansBold} from "@irati/ui/src/global/fonts"

export const BalanceWrapper = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.four} 0 ${theme.spacing.two};
    border-bottom: 1px solid ${theme.colors.primary2_50};
  `}
`
interface HeaderWrapperProps {
  selected?: boolean
}

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  justify-content: center;
  ${({theme, selected}) => selected && `background-color: ${theme.colors.utility.highlight};`}
  padding-left: 20px;
  border-radius: 4px;

  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.tablet`
      justify-content: flex-start;
    `}
  `}
`

export const BoldMessage = styled.span`
  ${WorkSansBold}
`

export const CreditCardImage = styled.img`
  display: block;
  margin-left: 10px;
  margin-right: auto;
  height: 30px;
`

export const PaymentsH2 = styled.p`
  font-family: ${({theme}) => theme.font.semibold};
  color: ${({theme}) => theme.colors.utility.ink};
  font-size: 16px;
  letter-spacing: 0.3px;
  word-break: break-all;
`
